import { css } from '@emotion/css';
import { theme } from 'antd';
import { useMemo } from 'react';

export const useCumulativeResultsCellStyles = (warn: boolean) => {
  const { token } = theme.useToken();
  return useMemo(
    () => ({
      value: css`
        width: 100%;
        color: ${warn ? token.colorError : token.colorTextSecondary};
        font-variant-numeric: tabular-nums;
      `,
      sub: css`
        color: ${token.colorTextTertiary};
        font-size: small;
        font-variant-numeric: tabular-nums;
      `,
      tag: css`
        margin-left: ${token.marginXS}px;
        font-size: small;
        padding-inline: ${token.paddingXXS}px;
      `,
      ellipsis: css`
        display: block;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      `,
    }),
    [token, warn]
  );
};
